import fb from './assets/icon-fb.svg'
import instagram from './assets/icon-instagram.svg'
import viber from './assets/icon-viber.svg'
import whatsapp from './assets/icon-whatsapp.svg'
import telegram from './assets/icon-telegram.svg'

export const PHONE = {
  value: '+380505772451',
  text: '+38 050 577 24 51',
}

export const LINK = {
  fb: 'https://www.facebook.com/toyshiku/',
  instagram: 'https://www.instagram.com/toyshiku/',
}

export const TEXT = {
  fb: 'Facebook',
  instagram: 'Instagram',
}

export const ICON = {
  fb,
  instagram,
  viber,
  whatsapp,
  telegram,
}
